import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { InvestmentInvitation } from 'api';
import StatusTag from 'src/ui/atoms/status-tag';

export const ProductInvitationsStatus: FunctionComponent<{
  invitation: InvestmentInvitation;
}> = ({ invitation }) => {
  const mapInvestmentInvitationStatus = (hasInvestment?: boolean) => {
    if (hasInvestment) return 'committed';
    return 'new';
  };

  return (
    <StatusTag variant="info" truncate={true}>
      <Translate name={`investmentInvitation.status.${mapInvestmentInvitationStatus(!!invitation.investment)}`} />
    </StatusTag>
  );
};
